import Vue from 'vue';
import Vuex from 'vuex';
import {isCurrentAppDefault} from 'utils/appTypeState';

export const FETCH_INITIAL = 'FETCH_INITIAL';

let store = null;

if (isCurrentAppDefault()) {
  Vue.use(Vuex);
  store = new Vuex.Store({
  });
}

export default store;
